import React from 'react'

import { StayConnectedStyled, StayConnectedTitleStyled, StayConnectedListStyled } from './styles'
import FollowUsButtons from './../../molecules/FollowUsButtons'
import { StayConnectedProps } from './types'

const StayConnected: React.FC<StayConnectedProps> = ({ data: { title, list } }) => {
  return (
    <StayConnectedStyled>
      {title && <StayConnectedTitleStyled>{title}</StayConnectedTitleStyled>}
      {list && (
        <StayConnectedListStyled>
          <FollowUsButtons isSmall data={list} />
        </StayConnectedListStyled>
      )}
    </StayConnectedStyled>
  )
}

export default StayConnected
